<div class="row">
  <p class="error">{{error_message}}</p>
</div>
<div *ngIf="loading" class="overlay">
  <div class="spinner"></div>
</div>

 
<blockquote>
    <h5 class="headings">LIST YOUR TOP THREE (3) MAJOR CUSTOMERS IN THE PAST THREE YEARS</h5>
</blockquote>

<form #form="ngForm" autocomplete="off">
  <div class="customer-form">
      <table style="width: 99%; margin-left: 18px;">
          <thead>
              <tr>
                  <th>Customer/Client</th>
                  <th>Year</th>
                  <th>Contract Value</th>
                  <th>Contact Person</th>
                  <th>Contact Number</th>
                  <th>Email Address</th>
              </tr>
          </thead>
          <tbody>
          <tr *ngFor="let customer of customers; let i = index; trackBy: trackByIndex"
              [hidden]="isViewOnly && customer.strPastCustomer.trim() === ''">
              <td>
                <input type="text" name="customer{{i}}" [(ngModel)]="customer.strPastCustomer" 
                [attr.placeholder]="customer.strPastCustomer ? customer.strPastCustomer : 'Enter name'" 
                [ngClass]="{'has-value': customer.strPastCustomer}" [readonly]="isViewOnly"
                (ngModelChange)="resetErrorMessage()">
              </td>
              <td>
                <input 
                  type="number" 
                  name="year{{i}}" 
                  [(ngModel)]="customer.dteYear" 
                  [attr.autocomplete]="'off'" 
                  [attr.placeholder]="customer.dteYear ? customer.dteYear.toString() : 'YYYY'"
                  [ngClass]="{'has-value': customer.dteYear}" [readonly]="isViewOnly"
                  min="1900" max="2099" 
                  (ngModelChange)="resetErrorMessage()">
              </td>
              <td>
                  <select
                    *ngIf="customer.strContractValue == ''"
                    style="display: block;"
                    name="value{{i}}"
                    [(ngModel)]="customer.strContractValue"
                    [disabled]="isViewOnly"
                    (ngModelChange)="resetErrorMessage()"
                    [ngClass]="{'has-value': customer.strContractValue}"
                  >
                    <option value="" disabled selected>Select contract value range</option>
                    <option *ngFor="let range of ranges" [value]="range">{{ range }}</option>
                  </select>
                  <div *ngIf="customer.strContractValue && customer.strContractValue !== ''"> 
                    <h6 style="margin-left: 30px;">
                      {{ customer.strContractValue }}
                      <button *ngIf="!isViewOnly" class="remove" style="display: inline-block;" (click)="removeCustomer(i)">x</button>
                    </h6>
                  </div>
              </td>
              <td>
                <input 
                  type="text" 
                  name="person{{i}}" 
                  [(ngModel)]="customer.strContactPerson" 
                  [attr.placeholder]="customer.strContactPerson ? customer.strContactPerson : 'Enter contact person'"
                  [ngClass]="{'has-value': customer.strContactPerson}" [readonly]="isViewOnly"
                  (ngModelChange)="resetErrorMessage()">
              </td>
              <td>
                <input 
                  type="text" 
                  name="number{{i}}" 
                  [(ngModel)]="customer.strContactNumber" 
                  [attr.placeholder]="customer.strContactNumber ? customer.strContactNumber : '1234567890'"
                  [ngClass]="{'has-value': customer.strContactNumber}" [readonly]="isViewOnly"
                  (ngModelChange)="resetErrorMessage()"
                  #phoneInput (input)="validatePhoneNumber(phoneInput.value, i)">
              </td>
              <td>
                <input 
                  type="text" 
                  name="email{{i}}" 
                  [(ngModel)]="customer.strContactEmail" 
                  [attr.placeholder]="customer.strContactEmail ? customer.strContactEmail : 'Enter email'"
                  [ngClass]="{'has-value': customer.strContactEmail}" [readonly]="isViewOnly"
                  (ngModelChange)="resetErrorMessage()"
                  #emailInput (input)="validateEmail(emailInput.value, i)">
              </td>
            </tr>
          </tbody>
      </table>
  </div>
  <div *ngIf="isViewOnly"><p style="font-style: italic; margin-left: 25px; color: grey;">End of List</p></div>
</form>


<form #form="ngForm">
    <br>
    <div class="card">
        <div class="radio-row">
          <h6>Were your contracts completed?</h6>
          <div class="radio-options">
            <label>
              <input name="group6" type="radio" [value]="true" [(ngModel)]="blnContractStatus" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">Yes</span>
            </label>
            <label>
              <input name="group6" type="radio" [value]="false" [(ngModel)]="blnContractStatus" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
              <span class="radio">No</span>
            </label>
          </div>
        </div>
        <div *ngIf="blnContractStatus === false">
            <h6>You selected NO, provide details: </h6>
            <input class="white-input" name="reason" [(ngModel)]="strContractDetails" [readonly]="isViewOnly" (ngModelChange)="resetErrorMessage()">
        </div>
      </div>
</form> 

<br>
<blockquote>
  <h5 class="headings">VENDOR'S STANDING IN INDUSTRIES</h5>
</blockquote>
<form>
  <div class="card">
      <div class="radio-row">
        <h6>Do you subcontract work?</h6>
        <div class="radio-options">
          <label>
            <input name="group6" type="radio" [value]="true" [(ngModel)]="subcontract" [disabled]="isViewOnly" (click)="addRow()" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">Yes</span>
          </label>
          <label>
            <input name="group6" type="radio" [value]="false" [(ngModel)]="subcontract" [disabled]="isViewOnly" (ngModelChange)="resetErrorMessage()"/>
            <span class="radio">No</span>
          </label>
        </div>
      </div>

      <div *ngIf="subcontract === true  && works.length">
        <br>
        <h6>You selected YES, identify primary works to be subcontracted out: </h6>
        <div *ngFor="let work of works; let i = index; trackBy: trackByFn" class="input-row">
          <input class="white-input" name="work" 
            [value]="work"
            (input)="updateWork($event, i)"
            [attr.placeholder]="work || 'Primary Work'" 
            [ngClass]="{'has-value': work}" 
            (ngModelChange)="resetErrorMessage()"
            [readonly]="isViewOnly">
          <button *ngIf="!isViewOnly && i > 0" class="delete-btn" (click)="removeRow(i)"><i class="material-icons icon-inline">clear</i></button>
        </div>
  
        <div class="btn-container">
          <button *ngIf="!isViewOnly" class="add-btn" (click)="addRow()">Add Another</button> 
        </div>
        
      </div>
  </div>
</form>